<template>
    <div class="form-collapes-sec mt-2">
        <div class="collapes-con-sec">
            <a class="btnArrow-down collapsed" data-bs-toggle="collapse" href="#collapseExample"
                role="button" aria-expanded="false" aria-controls="collapseExample">
                <div class="btnArrow-down-content">
                    <span>{{$t('view-guide-point', 'View guide point')}}</span>
                    <figure>{{$t('hide-guide-point', 'Hide guide point')}} </figure>
                </div>
                <div class="collapes-arrow">
                    <img loading="lazy" src="@/assets/images/arow-down.svg" alt="arow-down">
                </div>
            </a>
            <div class="collapse score-details" id="collapseExample">
                <div class="rule-guideline-wrapper p-0 mt-2">
                    <div class="guide-list">
                        <div class="guidePoint-details wallet-lang-tabs" id="collapseExample" v-if="hasRules">
                            <ul class="nav nav-pills mb-1" id="rules-tab" role="tablist">
                                <template v-for="(value, lang) in messages" :key="lang">
                                    <li class="nav-item" role="presentation" v-if="value && value?.length > 0">
                                        <button class="nav-link" :class="{ active: lang === activeLanguage }" :id="`rules-${lang}-tab`" data-bs-toggle="pill" :data-bs-target="`#pills-${lang}`"
                                            type="button" role="tab" :aria-controls="`rules-${lang}`" :aria-selected="lang === activeLanguage" @click="activeLanguage = lang">
                                            {{ lang }}
                                        </button>
                                    </li>
                                </template>
                            </ul>
                            <div class="tab-content" id="rules-tabContent">
                                <div class="tab-pane fade show active" v-for="(message, lang) in messages" 
                                    :key="lang" v-show="lang === activeLanguage"   :id="`rules-${lang}`" role="tabpanel" :aria-labelledby="`rules-${lang}-tab`">
                                    <div v-for="(point, index) in message" :key="index">
                                        <div class="guide-list1" v-html="point.description"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section v-else>
                            <ul v-if="instructionType == 'deposit'">
                                <li>{{ $t('deposit-money-only-in-the-below-available', 'Deposit money only in the below available accounts to get the fastest credits and avoid possible delays') }}.</li>
                                <li>{{ $t('deposits-made-45-minutes-after-the-account', 'Deposits made 45 minutes after the account removal from the site are valid & will be added to their wallets') }}.</li>
                                <li>{{ $t('site-is-not-responsible-for-money', 'Site is not responsible for money deposited to Old, Inactive or Closed accounts') }}.</li>
                                <li>{{$t('after-deposit-add-your-utr-and-amount', 'After deposit, add your UTR and amount to receive balance.')}}</li>
                                <li>{{$t('neft-receiving-time-varies', 'NEFT receiving time varies from 40 minutes to 2 hours.')}}</li>
                                <li>{{ $t('in-case-of-account-modification', 'In case of account modification: payment valid for 1 hour after changing account details in deposit page') }}.</li>
                            </ul>
                            <ul v-else>
                                <li>{{ $t('this-form-is-for-withdrawing-the-amount', 'This form is for withdrawing the amount from the main wallet only') }}.</li>
                                <li>{{ $t('the-bonus-wallet-amount-cannot-be-withdrawn', 'The bonus wallet amount cannot be withdrawn by this form') }}.</li>
                                <li>{{ $t('do-not-put-withdraw-request-without-betting-with', 'Do not put Withdraw request without betting with deposit amount. Such activity may be identified as Suspicious') }}.</li>
                                <li>{{ $t('If-multiple-users-are-using-same-withdraw', 'If multiple users are using same withdraw account then all the linked users will be blocked') }}.</li>
                                <li>{{ $t('maximum-withdraw-time-is-45-minutes-then-only-complain', 'Maximum Withdraw time is 45 minutes then only complain on WhatsApp number') }}.</li>
                            </ul>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['walletConfig'],
    mounted(){
        if (this.messages) {
            this.activeLanguage = Object.entries(this.messages).find(([lang, rules]) => rules.length > 0)?.[0] || null;
        }
    },
    data() {
        return {
            activeLanguage: null,
        };
    },
    computed: {
        messages() {
            return this.walletConfig?.rules?.[this.instructionType] || null;
        },
        hasRules() {
            if (!this.messages) return false;
            return Object.values(this.messages).some(arr => arr && arr.length > 0);
        }
    },
    props: ['instructionType']
};
</script>